import { createSelector } from "@reduxjs/toolkit"
import { RootState } from "./store"

export const selectLocation = (jid: string | undefined) => {
  return createSelector(
    (state: RootState) => state.locations,
    (locations) => {
      if (jid) {
        return locations[jid] ? locations[jid].location : undefined
      } else {
        return undefined
      }
    },
  )
}

export const selectLastLocationReceivedAt = (jid: string | undefined) => {
  return createSelector(
    (state: RootState) => state.locations,
    (locations) => {
      if (!jid) return undefined
      return locations[jid]?.receivedAt
    },
  )
}
